import React, { useState } from "react";
import style from "css/room.module.css";
import Location from "./Location";
import { EnvironmentFilled } from "@ant-design/icons";
import { DatePicker } from "antd";
// import { DatePicker, TimePicker } from "antd";

function Search({ location, setLocation, date, setDate }) {
  const [isOpenLocation, setIsOpenLocation] = useState(false);

  // const onOk = (value) => {
  //   console.log("onOk: ", value);
  // };

  // const onChange = (value, dateString) => {
  //   console.log("Selected Time: ", value);
  //   console.log("Formatted Selected Time: ", dateString);
  // };

  return (
    <>
      <Location
        isOpen={isOpenLocation}
        location={location}
        setLocation={(res) => setLocation(res)}
        onClose={() => setIsOpenLocation(false)}
      />

      <section className={style.search}>
        <p className={style.search_title}>장소/일시</p>

        <section className={style.search_input}>
          <div
            className={style.search_item}
            onClick={() => setIsOpenLocation(true)}
          >
            <p className={style.search_item_title}>위치</p>

            <div className={style.search_item_content}>
              <div className={style.search_item_location}>
                <EnvironmentFilled />
                <p
                  className={
                    location.id === ""
                      ? `${style.search_item_txt} ${style.search_item_placeholder}`
                      : style.search_item_txt
                  }
                >
                  {location.id === ""
                    ? "위치를 선택해 주세요."
                    : location.label}
                </p>
              </div>
            </div>
          </div>

          <div className={style.search_item}>
            <p className={style.search_item_title}>일시</p>
            <div className={style.search_item}>
              <DatePicker
                className={style.search_item_content}
                popupClassName={style.search_item_datepicker}
                allowClear={false}
                value={date}
                format="YYYY-MM-DD"
                onChange={(date) => setDate(date)}
                mode="date"
              />
              {/* <TimePicker.RangePicker
                className={style.search_item_content}
                allowClear={false}
                showTime={{
                  format: "HH:mm",
                  changeOnScroll: true,
                }}
                format="HH:mm"
                onChange={onChange}
                onOk={onOk}
                placeholder={["시작 시간", "종료 시간"]}
                minuteStep={10}
                value={[time.startTime, time.endTime]}
              /> */}
            </div>
          </div>
        </section>
      </section>
    </>
  );
}

export default Search;
